import React from 'react';
import MathText from './MathText';

// Inline "Complete the Words" cloze. The passage (member's side_text) carries {{1}}..{{n}} markers;
// marker n binds to the member with group_order === n (fallback: the n-th member in order). Each
// marker renders as an inline text input. Shared by the TOEFL model-test taker and the generic
// quiz taker (daily / published) so a cloze group presents identically in both.
//   members     — the group's questions (TEXT, each one blank)
//   answers     — { question_id: { text } }
//   onText      — (question_id, text) => void
//   numberByQid — optional { question_id: displayNo }; falls back to the {{n}} marker / group_order
export default function ClozePassage({ members, answers, onText, numberByQid }) {
    const sorted = [...members].sort((a, b) => (a.group_order || 0) - (b.group_order || 0));
    const passage = sorted[0]?.side_text || '';
    const byOrder = {};
    sorted.forEach((m, i) => { byOrder[m.group_order || (i + 1)] = m; });
    const parts = passage.split(/(\{\{\d+\}\})/g);
    let fallback = 0;
    return (
        <div style={{ lineHeight: 2.2, fontSize: '1.2rem', color: '#000000' }}>
            {parts.map((p, idx) => {
                const mk = p.match(/^\{\{(\d+)\}\}$/);
                if (!mk) return <MathText key={idx} text={p} />;
                const n = Number(mk[1]);
                const m = byOrder[n] || sorted[fallback++];
                if (!m) return <span key={idx}>____</span>;
                const val = (answers[m.question_id] && answers[m.question_id].text) || '';
                // Show the section-relative question number (chronological) when available.
                const label = (numberByQid && numberByQid[m.question_id]) || n;
                return (
                    <span key={idx} style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <sup style={{ color: '#6d28d9', fontWeight: 700, marginRight: 2 }}>{label}</sup>
                        <input
                            value={val}
                            onChange={(e) => onText(m.question_id, e.target.value)}
                            style={{ width: '5.5rem', border: 'none', borderBottom: '2px solid #6d28d9', outline: 'none', textAlign: 'left', paddingLeft: '0.15rem', fontSize: '1rem', background: '#faf5ff' }}
                        />
                    </span>
                );
            })}
        </div>
    );
}
